import 'moment/locale/es';
import 'moment/locale/it';
import 'moment/locale/fr';
import 'moment/locale/de';
import 'moment/locale/ja';
import 'moment/locale/zh-cn';
import 'moment/locale/ko';
import 'moment/locale/pt';
import 'moment/locale/nl';
import 'moment/locale/pl';
import 'moment/locale/sv';

const locales = [
  { name: '中文', value: 'zh-CN' },
  { name: 'Deutsch', value: 'de-DE' },
  { name: 'English', value: 'en-US' },
  { name: 'Español', value: 'es-ES' },
  { name: 'Français', value: 'fr-FR' },
  { name: 'Italiano', value: 'it-IT' },
  { name: '日本語', value: 'ja-JP' },
  { name: '한국어', value: 'ko-KR' },
  { name: 'Nederlands', value: 'nl-NL' },
  { name: 'Polski', value: 'pl-PL' },
  { name: 'Português', value: 'pt-PT' },
  { name: 'Svenska', value: 'sv-SE' },
];

const DOMAIN_TO_LOCALE_MAP: Record<string, string> = {
  localhost: 'en-US',

  'swiship.com': 'en-US',
  'swiship.integ.amazon.com': 'en-US',
  'swiship-preprod.amazon.com': 'en-US',

  'swiship.ca': 'en-CA',
  'swiship-ca.integ.amazon.com': 'en-CA',
  'swiship-ca-preprod.amazon.com': 'en-CA',

  'swiship.jp': 'ja-JP',
  'swiship-jp.integ.amazon.com': 'ja-JP',
  'swiship-jp-preprod.amazon.com': 'ja-JP',

  'swiship.com.au': 'en-AU',
  'swiship-au.integ.amazon.com': 'en-AU',

  'swiship.co.uk': 'en-GB',
  'swiship-co-uk.integ.amazon.com': 'en-GB',
  'swiship-co-uk-preprod.amazon.com': 'en-GB',

  'swiship.de': 'de-DE',
  'swiship-de.integ.amazon.com': 'de-DE',
  'swiship-de-preprod.amazon.com': 'de-DE',

  'swiship.es': 'es-ES',
  'swiship-es.integ.amazon.com': 'es-ES',
  'swiship-es-preprod.amazon.com': 'es-ES',

  'swiship.fr': 'fr-FR',
  'swiship-fr.integ.amazon.com': 'fr-FR',
  'swiship-fr-preprod.amazon.com': 'fr-FR',

  'swiship.it': 'it-IT',
  'swiship-it.integ.amazon.com': 'it-IT',
  'swiship-it-preprod.amazon.com': 'it-IT',
};

const stripWwwFromDomain = (domain: string): string => {
  return domain.replace('www.', '');
};

export const getLocaleFromDomain = (domain: string): string => {
  domain = stripWwwFromDomain(domain);
  return DOMAIN_TO_LOCALE_MAP[domain] || 'en-US';
};

export default locales;
